export default class MaterialShapesController {
  constructor(ProductsDataProvider, ProductPartsDataProvider, $stateParams) {
    "ngInject";
    this.ProductsDataProvider = ProductsDataProvider;
    this.ProductPartsDataProvider = ProductPartsDataProvider;

    let
      product = ProductsDataProvider.products.findOne({slug: $stateParams.product}),
      materials = product.materials,
      material = materials
        .find((material) => material.slug == $stateParams.material),
      productShapes = material
        .spec.shapes,
      allShapes = ProductPartsDataProvider
        .shapes
        .find({})
        .map((shape) => Object.assign({}, shape));

    allShapes.forEach((shape) => {
      shape.assigned = productShapes.some((productShape) => shape.id == productShape.id);
    });


    this.shapes = allShapes;
    this.product = product;
    this.material = material;
    this.filterState = "assigned";
  }

  filter(shapes) {
    switch (this.filterState) {
      case 'assigned':
        return shapes.filter((shape) => shape.assigned == true);
      case 'unassigned':
        return shapes.filter((shape) => shape.assigned != true);
      case 'all':
        return shapes;
      default:
        throw new Error("unsupported filter type for shapes")
    }
  }

  setFilterState(value, $event) {
    if ($event) {
      $event.preventDefault();
    }
    this.filterState = value;
  }

  changeShapeAssigment(shape, $event) {
    $event.preventDefault();
    shape.__loading = true;
    let
      actionName = '';
    if (shape.assigned) {
      actionName = 'deleteProductMaterialShape'
    } else {
      actionName = 'addProductMaterialShape';
    }
    this.ProductsDataProvider[actionName](
      this.product.id,
      this.material.id,
      shape.id
    ).then((responseShape) => {
      delete shape.__loading;
      shape.assigned = !shape.assigned;
    });
  }

  updateName(shape, $event) {
    $event.preventDefault();
    shape.__loading = true;
    this.ProductsDataProvider['updateName'](shape, 1).then((responseShape) => {
      delete shape.__loading;
    });
  }
}


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/products/components/material-shape-spec/controller.js
 **/